import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Phone, CalendarCheck, MapPin } from "lucide-react";
export default function ReadyToSchedule() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Handy Heroes - Electrical Services",
    telephone: "(470) 847-9076",
    areaServed: ["Atlanta", "Alpharetta", "Marietta", "Gwinnett", "Cobb"],
    url: "https://handyheroesatl.com/electrical-services/"
  };
  return <section id="readytoschedule" className="w-full bg-background py-16 md:py-24">
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(schema)
    }} />
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-4xl overflow-hidden rounded-2xl border border-border bg-card px-6 py-12 text-center shadow-lg md:px-12 md:py-16">
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            Ready to Schedule?
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-muted-foreground">
            Connect with independent electrical pros in your area. Ask your pro about availability and get a quote before work starts.
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row flex-wrap">
            <Button size="lg" asChild className="w-full sm:w-auto">
              <Link to="#bookingrequest">
                <CalendarCheck className="mr-2 size-5" />
                Request a Quote
              </Link>
            </Button>
            <Button size="lg" variant="secondary" asChild className="w-full sm:w-auto">
              <Link to="#bookingrequest">
                <MapPin className="mr-2 size-5" />
                Find a Pro Near You
              </Link>
            </Button>
            <Button size="lg" variant="outline" asChild className="w-full sm:w-auto">
              <a href="tel:+14708479076">
                <Phone className="mr-2 size-5" />
                (470) 847-9076
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}